var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89 6.918c0-.982.796-1.777 1.778-1.777h10.667c.98 0 1.778.795 1.778 1.777v7.112a1.78 1.78 0 01-1.778 1.777H4.668a1.779 1.779 0 01-1.777-1.777V6.918zm1.334 0v.614l4.792 3.934a1.55 1.55 0 001.972 0l4.792-3.934v-.639c0-.219-.2-.444-.445-.444H4.668a.462.462 0 00-.444.444v.025zm0 2.34v4.772c0 .244.199.444.444.444h10.667c.244 0 .444-.2.444-.444V9.257l-3.944 3.24a2.924 2.924 0 01-3.692 0l-3.919-3.24z",
    fill: "#FFBA33"
  })));
}
export default SvgIconMail;